import Region, { RegionType } from '@/creditflowresearch/domain/Region';
import { useCreateFilterButtons, type IFilterButtonsResult, type IFilterItem } from '@/creditflowresearch/ui/common/hooks/filters/useCreateFilterButtons';
import { useMarketState } from '@/creditflowresearch/ui/common/hooks/markets/useMarketState';
import { hasRegionAccess, type IRegionAccessControl } from '@/creditflowresearch/domain/Region/selectors/hasRegionAccess';

export const useMarketFilters = (preferredMarketIds?: string[]): IFilterButtonsResult => {
  const marketState = useMarketState(preferredMarketIds);
  const { marketsList, selectedMarketId, accessControl } = marketState;

  /*
  * TODO: Remove this function when the European market opening period ends
  * */
  const getEuropeanAccess = (regionId: string) => Region.isOfType(regionId, RegionType.EMEA);

  return useCreateFilterButtons<IFilterItem>(
    marketsList,
    selectedMarketId,
    marketState.setSelectedMarketId,
    {
      hasAccessCheck: (region) => getEuropeanAccess(region.id)
                                  || hasRegionAccess(region.id, accessControl as IRegionAccessControl),
      getTooltip: (market) => `View ${ market.name } market data`,
      getIsActive: (region, selected) => selected === region.id,
    },
  );
};
